import React from "react";
import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center pt-40 md:pt-44 pb-16 overflow-hidden bg-brand-blue-deep">
      {/* Background Molecular Image with Dark Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-10000 ease-out scale-105"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?q=80&w=1920&auto=format&fit=crop')`,
        }}
      />
      {/* Overlay: Clinical Blue Gradient to Stark white */}
      <div className="absolute inset-0 bg-gradient-to-tr from-brand-blue-deep via-brand-blue/90 to-brand-blue/30 mix-blend-multiply" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-blue-deep/50 to-brand-blue-deep" />

      {/* Animated Floating Particles (SVG) */}
      <div className="absolute inset-0 pointer-events-none opacity-20">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10%" cy="20%" r="4" fill="#00A8B5" className="animate-pulse" />
          <circle cx="80%" cy="30%" r="6" fill="#00A8B5" className="animate-pulse" style={{ animationDelay: '1s' }} />
          <circle cx="25%" cy="70%" r="5" fill="#ffffff" className="animate-pulse" style={{ animationDelay: '2s' }} />
          <circle cx="70%" cy="80%" r="3" fill="#00A8B5" className="animate-pulse" style={{ animationDelay: '1.5s' }} />
          {/* Connecting lines representing molecular bonds */}
          <path d="M10% 20% L25% 70% M80% 30% L70% 80%" stroke="rgba(0,168,181,0.2)" strokeWidth="1" />
        </svg>
      </div>

      {/* Hero Content Container */}
      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center text-white z-10">
        {/* Small Highlight Tag */}
        <div className="inline-flex items-center space-x-2 bg-brand-teal/20 border border-brand-teal/30 rounded-full px-4 py-1.5 mb-8 animate-fade-in">
          <span className="w-2 h-2 rounded-full bg-brand-teal animate-ping" />
          <span className="text-brand-teal-light font-semibold text-xs uppercase tracking-wider">
            Development Partner
          </span>
        </div>

        {/* Tagline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.1] mb-6 animate-fade-in-up">
          Reducing the Burden of{" "}
          <span className="bg-gradient-to-r from-brand-teal-light via-brand-teal to-cyan-300 bg-clip-text text-transparent">
            Healthcare
          </span>
        </h1>

        {/* Sub-headline */}
        <p className="max-w-3xl mx-auto text-base md:text-xl text-slate-300 font-light leading-relaxed mb-10 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          A research-driven “Product Development” partner for <br /><b>Generics | Complex Generics | iNnovative Healthcare Solutions</b>, <br />specializing in scalable, reproducible, and affordable drug delivery systems.

        </p>

        {/* Buttons / CTA */}
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <Link
            to="/ContactUs"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full text-white font-semibold text-base bg-gradient-to-r from-brand-teal to-brand-teal-dark hover:from-brand-teal-light hover:to-brand-teal shadow-xl shadow-brand-teal/20 transition-all duration-300 transform hover:-translate-y-0.5 text-center"
          >
            Collaborate with Us
          </Link>
          <a
            href="#capabilities"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("capabilities")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="w-full sm:w-auto px-8 py-3.5 rounded-full text-white hover:text-brand-teal font-semibold text-base border border-white/20 hover:border-brand-teal/50 bg-white/5 hover:bg-white/10 backdrop-blur-sm transition-all duration-300 text-center"
          >
            Explore R&D Capabilities
          </a>
        </div>
      </div >

      {/* Decorative Wave/Bottom Curve */}
      < div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0] transform rotate-180" >
        <svg className="relative block w-full h-[60px]" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" fill="#F7F9FA"></path>
        </svg>
      </div >
    </section >
  );
}
